// briefStaleness.js — has anything been logged since the Home brief was
// generated? (2026-10-20) A brief is a snapshot; one generated at 8 AM still
// says "Gym is open" after a 9 AM tick. The card shows "Updated since this
// brief · Refresh" — no auto-regenerate, no API call. Pure, unit-tested.
//
// Only real log INSTANTS count: habits.last_logged_at, workouts.created_at,
// moods.logged_at. A missing instant (rows logged before last_logged_at
// existed) is unknown, never "after the brief".

const ms = (v) => { if (!v) return null; const t = Date.parse(v); return Number.isFinite(t) ? t : null; };

/**
 * @param {string|null} generatedAt  the brief's generated_at (ISO)
 * @param {{ habits?: Array<{lastLoggedAt?: string}>, workouts?: Array<{created_at?: string}>, moods?: Array<{loggedAt?: string}> }} logs
 * @returns {boolean}
 */
export function briefUpdatedSince(generatedAt, { habits = [], workouts = [], moods = [] } = {}) {
  const gen = ms(generatedAt);
  if (gen == null) return false;
  const after = (v) => { const t = ms(v); return t != null && t > gen; };
  return (habits || []).some(h => h && after(h.lastLoggedAt))
    || (workouts || []).some(w => w && after(w.created_at))
    || (moods || []).some(m => m && after(m.loggedAt));
}
